<template>
  <div class="of-h" v-loading="loading">
    <div class="flex-box al-c card-title">
      <!-- <img class="ml10 mr5" :src="`${baseUrl}images/icon-home-serve.png`"> -->
      <i class="myfont icon-jifen"></i>
      <span class="font-20">个人服务</span>
    </div>

    <el-row class="w100" v-loading="loading">
      <el-col :span="col" v-for="(item, index) in list" :key="index">
        <!-- <a class="block w100 pt20 cu-p tx-c app-item" target="_blank" :href="item.linkUrl" @click="serverInsert(item)"> -->
        <a class="block w100 pt20 cu-p tx-c app-item" @click="serverInsert(item)">
          <img class="app-img" :src="item.logo ? item.logo : `${baseUrl}images/icon-app.png`" style="width: 60px; height: 60px; border-radius: 50%;">
          <!-- <el-image class="app-img" :src="item.logo" lazy style="width: 60px; height: 60px; border-radius: 50%;">
            <img :src="`${baseUrl}images/icon-app.png`" width="60" height="60" slot="error">
          </el-image> -->
          <p class="mt10 pl20 pr20 font-14 ellipsis">{{ item.serveName }}</p>
        </a>
      </el-col>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无可用服务</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CardServe",
  components: {},
  props: ["w", "h"],
  data() {
    return {
      loading: false,
      baseUrl: process.env.BASE_URL,
      list: [],
      pageNum: 1,
      col: 8,
    };
  },
  computed: {
    pageSize() {
      return this.w * 3 * (this.h * 2);
    },
  },
  created() {
    this.fetchList();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "/hallServe/servePermitList",
          this.$qs.stringify({
            pageNum: 1,
            pageSize: this.pageSize,
            recommend: "",
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.$nextTick(() => {
              this.computeCol();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 访问统计计数器
    serverInsert(item) {
      switch (item.serveType * 1) {
        case 0:
          this.$router.push({
            path: `/serveSearch/${item.id}/${item.interfaceUrl}`,
          });
          break;
        case 1:
          this.$router.push({
            path: `/serveApproval/${item.id}`,
          });
          break;
        case 2:
          this.$router.push({
            path: `/serveCustomized/${item.id}/${item.interfaceUrl}`,
          });
          break;
        case 9:
          this.$http
            .post(
              "/statistical/serverInsert",
              this.$qs.stringify({
                serviceId: item.id,
                appType: 9,
              })
            )
            .then(() => {})
            .catch(() => {});

          this.url = this.data.linkUrl;
          this.$refs.url.click();
          break;
        default:
          break;
      }
    },
    // 每次获取计算列个数
    computeCol() {
      switch (this.w) {
        case 1:
          this.col = 8;
          break;
        case 2:
          this.col = 4;
          break;
        case 3:
          this.col = 3;
          break;
        default:
          break;
      }
    },
    resizedEvent() {
      this.fetchList();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped>
.card-title {
  height: 40px;
}

.card-title i {
  color: #619df8;
  font-size: 20px;
  margin-left: 10px;
  margin-right: 5px;
}

.app-item {
  height: 140px;
}

.app-item:hover {
  background: #edf5fe;
}
.app-img {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>